import { render, staticRenderFns } from "./margins-container.vue?vue&type=template&id=97763066"
import script from "./margins-container.vue?vue&type=script&lang=js"
export * from "./margins-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports